// import { useEffect } from "react"
// import { FieldError } from "react-hook-form"
// import createUser from "@/hooks/usePostCreateUser"
import GoogleSignIn from "./GoogleSignIn"
// import FacebookSignIn from "./FacebookSignIn"
// import ControlledDropDown from "../controlledInputs/ControlledDropDown"

import { z } from "zod"
import { Box, Typography } from "@mui/material"
// import ControlledTextInput from "../controlledInputs/ControlledTextInput"
// import ControlledCheckBox from "../controlledInputs/ControlledCheckBox"
// import {
//   Box,
//   Button,
//   Divider,
//   Grid,
//   IconButton,
//   InputAdornment,
//   MenuItem,
//   Typography,
// } from "@mui/material"
// import { zodResolver } from "@hookform/resolvers/zod"
// import { Visibility, VisibilityOff } from "@mui/icons-material"
// import { loginUser } from "@/hooks/usePostLogin"
// import useIsMobile from "@/hooks/useIsMobile"

const registerFormData = z
  .object({
    firstName: z.string().min(1, { message: "First name is required" }),
    lastName: z.string().min(1, { message: "Last name is required" }),
    email: z.string().email().min(1, "Please enter your email address."),
    confirmEmail: z
      .string()
      .email()
      .min(1, { message: "Please confirm your email." }),
    password: z
      .string()
      .min(8, { message: "Password must be at least 8 characters long" }),
    confirmPassword: z
      .string()
      .min(8, { message: "Password must be at least 8 characters long" }),
    month: z.string().min(1, { message: "Month is required" }),
    day: z.number().min(1, { message: "Day is required" }),
    year: z.number().min(1, { message: "Year is required" }),
    gender: z.enum(["male", "female", "other"]).optional(),
  })
  .refine(
    (data) =>
      data.gender === "male" ||
      data.gender === "female" ||
      data.gender === "other",
    {
      message: "Please select one gender option.",
    }
  )
  .refine((data) => data.password === data.confirmPassword, {
    message: "The passwords must match.",
    path: ["confirmPassword"], // This sets which field the error is attached to
  })
  .refine((data) => data.email === data.confirmEmail, {
    message: "The emails must match.",
    path: ["confirmEmail"],
  })

// Define TypeScript type based on the schema
export type RegisterFormDataType = z.infer<typeof registerFormData>

// const defaultValues: RegisterFormDataType = {
//   email: "",
//   confirmEmail: "",
//   firstName: "",
//   lastName: "",
//   password: "",
//   confirmPassword: "",
//   month: "",
//   day: 1,
//   year: 1993,
//   gender: undefined,
// }

// interface CreateNewAccountProps {
//   handleClose: () => void
// }

// { handleClose }: CreateNewAccountProps
const CreateNewAccount = () => {
  // const isMobile = useIsMobile()
  // const {
  //   // handleSubmit,
  //   // reset,
  //   // control,
  //   formState: { errors },
  // } = useForm<RegisterFormDataType>({
  //   resolver: zodResolver(registerFormData),
  //   defaultValues: defaultValues,
  // })

  // const [successMessage, setSuccessMessage] = useState("")
  // const [errorMessage, setErrorMessage] = useState<string | undefined>(
  //   undefined
  // )

  // const onSubmit: SubmitHandler<RegisterFormDataType> = async (data) => {
  //   console.log("Form submitted successfully:", data)

  //   // else create user
  //   await createUser({ email: data.email, password: data.password })
  //     .then((res) => {
  //       if (res.message) {
  //         setErrorMessage("")
  //         // setSuccessMessage(res.message)
  //       }
  //       if (res.error) {
  //         // setSuccessMessage("")
  //         setErrorMessage(res.error)
  //       }
  //       console.log("Response: ", res)
  //     })
  //     .catch((error) => {
  //       console.log("Error: ", error)
  //       // setSuccessMessage("")
  //       setErrorMessage(error)
  //     })
  //   // }

  //   console.log("test here")

  //   await loginUser({ email: data.email, password: data.password })
  //   handleClose()
  // }

  // const formInputStyling = {
  //   backgroundColor: "#F0F2F5",
  //   borderRadius: "8px",
  //   height: "54px",
  // }

  // const months = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  //   "August",
  //   "September",
  //   "October",
  //   "November",
  //   "December",
  // ]

  // const days = Array.from({ length: 31 }, (_, i) => i + 1)
  // const currentYear = new Date().getFullYear()
  // const years = Array.from({ length: 100 }, (_, i) => currentYear - i)

  // show password button
  // const [showPassword, setShowPassword] = useState(false)
  // const handleClickShowPassword = () => setShowPassword(!showPassword)
  // const handleMouseDownPassword = () => setShowPassword(!showPassword)

  // show confirm password button
  // const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  // const handleClickShowConfirmPassword = () =>
  //   setShowConfirmPassword(!showConfirmPassword)
  // const handleMouseDownConfirmPassword = () =>
  //   setShowConfirmPassword(!showConfirmPassword)

  // Utility function to get the first error message with the field name
  // const getFirstErrorMessage = (
  //   errors: Record<string, FieldError | undefined>
  // ): string | undefined => {
  //   for (const [key, value] of Object.entries(errors)) {
  //     if (value) {
  //       return `${value.message}`
  //     }
  //   }
  //   return undefined
  // }

  // useEffect(() => {
  //   // handle errors
  //   const firstErrorMessage = getFirstErrorMessage(Object(errors))
  //   setErrorMessage(firstErrorMessage)
  // }, [errors])
  return (
    <>
      <section
        className="modal-card-body"
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          paddingBottom: 0,
        }}
      >
        {/* Login through Google or Facebook */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // maxWidth: "350px",
          }}
        >
          <GoogleSignIn />
          <Box>
            <Typography textAlign="center">
              More Options Coming Soon!
            </Typography>
          </Box>
          {/* <FacebookSignIn /> */}
        </div>
      </section>
      {/* <section
        style={{
          backgroundColor: "white",
          textAlign: "center",
          fontWeight: "bold",
          color: "black",
        }}
      >
        <hr
          style={{
            backgroundColor: "#F0F2F5",
            height: "2px",
            border: 0,
            marginBottom: "1rem",
          }}
        />
        <Typography variant="h5">or</Typography>
      </section> */}
      {/* <form onSubmit={handleSubmit(onSubmit)}>
        
        <Grid
          container
          rowSpacing={1.5}
          columnSpacing={{ xs: 1, sm: 3, md: 3 }}
          sx={{ marginTop: ".5rem", maxWidth: "500px" }}
        >
          <Grid item xs={6}>
            <ControlledTextInput
              control={control}
              formInputStyling={formInputStyling}
              name="firstName"
              label="First Name"
              type="text"
            />
          </Grid>
          <Grid item xs={6}>
            <ControlledTextInput
              control={control}
              formInputStyling={formInputStyling}
              name="lastName"
              label="Last Name"
              type="text"
            />
          </Grid>

          <Grid item xs={6}>
            <ControlledTextInput
              control={control}
              formInputStyling={formInputStyling}
              name="email"
              label="Email"
              type="text"
            />
          </Grid>
          <Grid item xs={6}>
            <ControlledTextInput
              control={control}
              formInputStyling={formInputStyling}
              name="confirmEmail"
              label="Confirm Email"
              type="text"
            />
          </Grid>
          <Grid item xs={6}>
            <ControlledTextInput
              control={control}
              formInputStyling={formInputStyling}
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"} // <-- This is where the magic happens
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
          <Grid item xs={6}>
            <ControlledTextInput
              control={control}
              formInputStyling={formInputStyling}
              name="confirmPassword"
              label="Confirm Password"
              type={showConfirmPassword ? "text" : "password"} // <-- This is where the magic happens
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle confirm password visibility"
                    onClick={handleClickShowConfirmPassword}
                    onMouseDown={handleMouseDownConfirmPassword}
                  >
                    {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
            />
          </Grid>
          <Grid item xs={6} sx={{ display: "flex", marginTop: ".8rem" }}>
            <Typography
              variant="subtitle2"
              sx={{
                paddingLeft: "1rem",
                width: "100px",
              }}
            >
              Date of Birth
            </Typography>

            <ControlledDropDown control={control} label="Month" name="month">
              {months.map((element, index) => (
                <MenuItem key={index} value={element}>
                  {element}
                </MenuItem>
              ))}
            </ControlledDropDown>
          </Grid>
          <Grid item xs={6} sx={{ display: "flex", marginTop: ".8rem" }}>
            <ControlledDropDown control={control} label="Day" name="day">
              {days.map((element, index) => (
                <MenuItem key={index} value={element}>
                  {element}
                </MenuItem>
              ))}
            </ControlledDropDown>
            <ControlledDropDown control={control} label="Year" name="year">
              {years.map((element, index) => (
                <MenuItem key={index} value={element}>
                  {element}
                </MenuItem>
              ))}
            </ControlledDropDown>
          </Grid>
          <Controller
            control={control}
            name="gender"
            render={({ field: { onChange, value } }) => (
              <>
                <Grid item xs={6} sx={{ display: "flex" }}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      marginRight: ".5rem",
                      width: "100px",
                      paddingLeft: "1rem",
                    }}
                  >
                    Gender
                  </Typography>
                  <ControlledCheckBox
                    label="Male"
                    control={control}
                    name="gender"
                    checked={value === "male"}
                    onChange={() => onChange("male")}
                  />
                </Grid>
                <Grid item xs={6} sx={{ display: "flex" }}>
                  <ControlledCheckBox
                    label="Female"
                    control={control}
                    name="gender"
                    checked={value === "female"}
                    onChange={() => onChange("female")}
                  />
                  <ControlledCheckBox
                    label="Other"
                    control={control}
                    name="gender"
                    checked={value === "other"}
                    onChange={() => onChange("other")}
                  />
                </Grid>
              </>
            )}
          />
        </Grid>

        <Box sx={{ textAlign: "center", padding: "1rem" }}>
          {errorMessage && (
            <Typography variant="caption" color="text.warning">
              {errorMessage}
            </Typography>
          )}
        </Box>

        <Divider sx={{ mb: "1rem" }} />
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="outlined"
            className="button is-error"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            className="button is-success"
            type="submit"
            // onClick={handleSubmit}
          >
            Create
          </Button>
        </Box>
      </form> */}
    </>
  )
}

export default CreateNewAccount
